import CrudErrors from "../CrudErros";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";

const ServiceGroupCrudForm = ({setForm, form, createData, updateData, handleReset, errors}) => {
    let myAbi = HelpAbility();
    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    }

    const handleChangeBool = (e) => {
        setForm({...form, [e.target.name]: e.target.value === 'true'});
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (form._id === null) {
            createData(form);
        } else {
            updateData(form);
        }
    }

    const isVisibleForm = () => (form._id === null) ? myAbi.has(C.A.SERVICE.CREATE) : myAbi.has(C.A.SERVICE.UPDATE);

    return (
        <>
            {isVisibleForm() && <>
                <h3 className="text-center">{form._id ? 'Editar' : 'Agregar'} Grupo</h3>
                {errors && <CrudErrors errors={errors}/>}
                <div className="mb-3">
                    <label htmlFor="code" className="form-label">Código</label>
                    <input type="text" className="form-control" id="code" name="code" autoComplete="off"
                           disabled={!!form._id}
                           value={form.code} onChange={handleChange}/>
                    <div id="codeHelp" className="form-text">El código debe ser único</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">Nombre</label>
                    <input type="text" className="form-control" id="name" name="name" value={form.name}
                           autoComplete="off"
                           onChange={handleChange}/>
                </div>
                <div className="mb-3">
                    <label htmlFor="description" className="form-label">Descripción</label>
                    <textarea className="form-control" id="description" name="description" value={form.description}
                              onChange={handleChange}/>
                </div>
                <div className="mb-3">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="isVisible" onChange={handleChangeBool}
                               checked={form.isVisible === true} id="isVisible-radio-true" value={true}/>
                        <label className="form-check-label" htmlFor="isVisible-radio-true">Visible</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="isVisible" onChange={handleChangeBool}
                               checked={form.isVisible === false} id="isVisible-radio-false" value={false}/>
                        <label className="form-check-label" htmlFor="isVisible-radio-false">No Visible</label>
                    </div>
                </div>
                <button type="submit" className="btn btn-primary me-2" onClick={handleSubmit}><i
                    className="bi bi-save"/> Guardar
                </button>
                <button type="reset" className="btn btn-secondary" onClick={handleReset}><i
                    className="bi bi-eraser"/> Limpiar
                </button>
            </>}
        </>
    );
}
export default ServiceGroupCrudForm;
